import * as React from 'react';
import * as UserRepository from '../../../Repository/UserRepository';
import * as TreeTypeRepository from '../../../Repository/TreeTypeRepository';
import { Form, Input, message, Select } from 'antd';
import { FormInstance } from 'antd/lib/form';
import CRUDModal from '../../../Component/Modal/CRUDModal';
import { User } from 'tree-wallet-client';
import { SelectValue } from '../../../Component/MultipleRemoteSelector';
import { Translations } from "../../../Repository/TreeTypeRepository";

interface ModalContractFormGenericProps extends React.PropsWithChildren {
  onClose?: Function;
  onSave?: Function;
  onOpen?: Function;
  openButton: React.ReactNode;
  editedObject?: any;
  modalTitle: string;
}

interface ModalContractFormGenericState{
  error: any;
  submitting: boolean;
}

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};

export default class ModalNewContractFormGeneric extends React.Component<ModalContractFormGenericProps, ModalContractFormGenericState>{
  private formRef: React.RefObject<FormInstance>;

  constructor(props: ModalContractFormGenericProps) {
    super(props);
    this.formRef = React.createRef();
    this.onFinish = this.onFinish.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onFinishFailed = this.onFinishFailed.bind(this);
    this.state = {
      error: undefined,
      submitting: false,
    }
  }

  onCancel() {
    const { current: form } = this.formRef;
    form && form.resetFields();
  }

  onFinishFailed(error: any) {
    this.setState({ error })
  }

  async onFinish() {
    const { onSave, editedObject } = this.props;
    const { current: form } = this.formRef;

    if (form) {
      form.validateFields()
        .then(async (values: any) => {
          const formData = new FormData();
          Object.entries(values).map(([key, value]) => formData.append(key, String(value)))
          onSave && await onSave(editedObject, values);
        })
        .then(() => {
          // form.resetFields();
        })
        .catch((info: any) => {
          message.error(info);
        });
    }
  }

  async fetchUserList(username: string): Promise<SelectValue[]> {
    return UserRepository.getAdminUsersList({
      params: {
        filters: JSON.stringify([
          { field: "role", value: "ROLE_TREE_PLANTER" },
          { field: "search", value: username }
        ])
      }
    })
    .then((body) => {
      return body.map((user: User) => ({
        label: `${user.firstName} ${user.lastName}`,
        value: user.id
      })
    )});
  }

  async fetchTreeTypesList(): Promise<SelectValue[]> {
    return TreeTypeRepository.getTreeTypesList({})
    .then((body: any) => {
      return body.map((treeType: any) => ({
        label: treeType.translations.latin,
        value: treeType.id
      })
    )});
  }

  render() {
    const { openButton, editedObject, modalTitle } = this.props;

    return <CRUDModal
      editedObject={editedObject}
      openButton={openButton}
      modalTitle={modalTitle}
      onSave={this.onFinish}
      onCancel={this.onCancel}
      closeAfterSave={true}
    >
      <Form
        {...layout}
        name="basic"
        ref={this.formRef}
        onFinish={this.onFinish}
        onFinishFailed={this.onFinishFailed}
        initialValues={{ ...(editedObject ? editedObject : {}) }}
      >
        <Form.Item
          label="Description"
          name="description"
          rules={[{ required: true, message: 'Please enter a description' }]}
        >
          <Input placeholder="Description" />
        </Form.Item>

        <Form.Item
          label="Language"
          name="language"
          rules={[{ required: true, message: 'Please select a language' }]}
        >
          <Select options={Translations.map((translation: string) => {
            return { label: translation, value: translation };
          })}>
          </Select>
        </Form.Item>
      </Form>
    </CRUDModal>
  }
}
